/**
 * Shared constants for the Edit page and related components.
 * Extracted from Edit.jsx to improve maintainability.
 */

// Re-export status utilities from statusUtils.js (single source of truth)
export {
  statusColors,
  statusLabels,
  statusTooltips,
  getDisplayStatus,
  getStatusLabel,
  getStatusColor,
  getStatusTooltip,
  mapFiltersToApiStatus,
  photoMatchesFilters,
} from './statusUtils';

// V2: Hide pipeline statuses from edit view
// (detecting/identifying deprecated but kept for historical data)
export const hiddenStatuses = new Set([
  'ingested',
  'processing',
  'detecting', // DEPRECATED
  'identifying', // DEPRECATED
  'pipeline',
]);

// LocalStorage keys
export const STORAGE_KEYS = {
  TAG_FILTER_PREF: 'tagging-filters',
  TAG_LAST_IMAGE: 'tagging-last-image',
  CROP_STEP: 'tagging-crop-mode',
  RAIN_PREF: 'matrix-rain-enabled',
  SIDEBAR_COLLAPSED: 'tagging-sidebar-collapsed',
  FACES_BAR_COLLAPSED: 'tagging-faces-collapsed',
  SKIP_INCOMPLETE_MODAL: 'tagging-skip-incomplete-modal',
  DEVELOP_CLIPBOARD: 'matrix-develop-clipboard',
  SHOW_HOTKEYS: 'matrix-show-hotkeys',
  SHOW_LEGEND: 'matrix-show-legend',
  SORT_ORDER: 'matrix-sort-order',
  PREVIEW_EXPORT_NOTICE_DISMISSED: 'matrix-preview-export-notice-dismissed',
  VIZ_LAYERS_PRESET: 'matrix-viz-layers-preset',
  MATCH_GROUPING: 'matrix-match-grouping',
};

// V2 filter options for photo list
// Order: actionable items first (tagging, review), then other states
export const filterOptions = [
  { value: 'tagging', label: 'Tagging' }, // pending + has_unlabeled_faces
  { value: 'review', label: 'Review' }, // pending + no unlabeled faces
  { value: 'attention', label: 'Attention' }, // attention status (e.g., no faces)
  { value: 'done', label: 'Done' },
  { value: 'error', label: 'Error' },
  { value: 'exported', label: 'Exported' },
];

// Default filter when none selected (empty = show all, unfiltered)
export const DEFAULT_FILTERS = [];

// Fixed 3:2 aspect ratio for sports photography
export const CROP_ASPECT = 3 / 2;

// Sentinel detect image width (coordinates in detect-space use this reference)
export const DETECT_IMAGE_WIDTH = 2000;

// Crop sizing defaults
export const DEFAULT_CROP_SIZE_RATIO = 0.8; // 80% of display for initial crop
export const FACE_CROP_PADDING_RATIO = 0.2; // 20% padding for face thumbnails
export const MIN_CROP_SIZE = 50; // Minimum crop dimension in pixels

// Pagination settings
export const FACES_PER_PAGE = 3;
export const FACES_PER_STUB_PAGE = 12;

// High confidence threshold for neighbor matching (80%)
export const HIGH_CONFIDENCE_THRESHOLD = 0.8;

// Valid sort orders
export const VALID_SORT_ORDERS = [
  'newest',
  'oldest',
  'filename_asc',
  'filename_desc',
  'capture_newest',
  'capture_oldest',
];
